import React, { useState, useEffect } from 'react';
import { getPendingCount } from '../utils/offlineDb';

const ConnectionStatus = ({ isSyncing, onSyncComplete }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine);
    };

    const updatePendingCount = async () => {
      const count = await getPendingCount();
      setPendingCount(count);
    };

    // Update online status
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    // Update pending count periodically
    updatePendingCount();
    const interval = setInterval(updatePendingCount, 5000);

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
      clearInterval(interval);
    };
  }, []);

  // Determine status
  let status = 'online';
  let statusText = 'Online';
  let statusColor = 'bg-green-500';
  let icon = '🟢';

  if (isSyncing) {
    status = 'syncing';
    statusText = 'Menyinkronkan...';
    statusColor = 'bg-yellow-500';
    icon = '🔄';
  } else if (!isOnline) {
    status = 'offline';
    statusText = 'Mode Offline';
    statusColor = 'bg-red-500';
    icon = '🔴';
  }

  return (
    <div className="fixed top-20 right-4 z-40">
      <div className={`${statusColor} text-white px-3 py-1.5 rounded-lg shadow-lg flex items-center gap-2 animate-fade-in`}>
        <span className={isSyncing ? 'animate-spin' : ''}>{icon}</span>
        <span className="font-medium text-sm">{statusText}</span>
        {!isOnline && pendingCount > 0 && (
          <span className="bg-white text-red-600 px-2 py-0.5 rounded-full text-xs font-bold">
            {pendingCount}
          </span>
        )}
      </div>
    </div>
  );
};

export default ConnectionStatus;